import React from 'react';
import { useTheme } from 'styled-components';
import { createRoot } from 'react-dom/client';
import PropTypes from 'prop-types';
import { GlobalPropsProvider, useGlobalProps } from 'providers/global-props';
import { isScreenSize } from 'newJs/utils';
import { Nav, Link } from './Component';
import { openPopupLink, getCurrComposeLink } from 'src/js/utils';
import Button from 'components/Button';

const NavBarApp = ({ data }) => {
    const { containerId, i18n, isBizMail, links = {}, siteName } = data;
    const { user, user: { prefs } } = useGlobalProps();
    const { path, search } = getCurrComposeLink();
    const { breakpoint } = useTheme();

    if (links.news) {
        let tempUrl = new URL(links.news);
        tempUrl.searchParams.append('language', user.locale);
        links.news = tempUrl.toString();
    }

    const handleClick = (e) => {
        if (!prefs.composeInPopup) return;
        const aTag = e.target.closest('a');
        if (!aTag) return;

        const url = new URL(aTag.href);
        if (url.pathname === '/compose' && prefs.composeInPopup) {
            e.preventDefault();
            const href = `${path}?${search}`;
            return openPopupLink(href);
        }
    };

    return (
        <Nav id={`${containerId}_primary`} onClick={handleClick}>
            {!isBizMail && (
                <Button
                    as={Link}
                    href={links.home}
                    id="mail-menu__link_go-home"
                    title={siteName}
                    data-test="btn-go-home"
                >
                    <Link.Icon name="prod-home" />
                </Button>
            )}
            <Button
                as={Link}
                href={links.contacts}
                id="mail-menu__link_contacts"
            >
                <Link.Icon name="prod-contacts" />
                {!isScreenSize.xs(breakpoint.name) && <Link.Text>{i18n.contacts}</Link.Text>}
            </Button>
            {links.files && (
                <Button
                    as={Link}
                    href={links.files}
                    id="mail-menu__link_go-to-files"
                >
                    <Link.Icon name="prod-files" />
                    {!isScreenSize.xs(breakpoint.name) && <Link.Text>{i18n.files}</Link.Text>}
                </Button>
            )}
            {links.news && (
                <Button
                    as={Link}
                    href={links.news}
                    id="mail-menu__link_go-to-news"
                    target="_blank"
                >
                    <Link.Icon name="prod-news" />
                    {!isScreenSize.xs(breakpoint.name) && <Link.Text>{i18n.news}</Link.Text>}
                </Button>
            )}
        </Nav>
    );
};

NavBarApp.propTypes = { data: PropTypes.object.isRequired };
let navbarRoot = null;

export default (container, inx, INBOX) => {
    const { mail, params } = inx;
    const { store: { MAPI, dataStorage } } = INBOX;
    const globalProps = {
        MAPI, dataStorage,
        i18n: inx.i18n,
        pageName: mail.params.pageName,
        selectors: mail.selectors,
        user: params.user,
    };

    const element = document.getElementById('main-site-nav-old');
    element.className = 'main-site-nav';
    element.style.minHeight = '36px';

    if (!navbarRoot) {
        navbarRoot = createRoot(container);
    }

    navbarRoot.render(
        <GlobalPropsProvider provideQuery value={globalProps}>
            <NavBarApp data={{
                ...mail.mainNav,
                i18n: inx.i18n.mainNavbar,
                isBizMail: params.mailType.isBizMail,
            }} />
        </GlobalPropsProvider>
    );
};